module.exports = __webpack_public_path__ + "static/hut-doodle-42672391921b30d621ce435c5618480c.jpg";